import { useEffect, useState } from "react";
import { playerService } from "../../services/api";

// Paket Injuries (Marin 16.09.2026): loads availability + injury history for the player hero pill and the
// history block in the Transfers tab. Resolves to the payload when the backend has platform data
// (`available: true`), otherwise null (loading, error, 404, available:false). Aborts on player change / unmount.
export const usePlayerInjuries = (playerId) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!playerId) {
      setResult(null);
      return undefined;
    }
    const controller = new AbortController();
    let alive = true;
    setResult(null);
    (async () => {
      try {
        const res = await playerService.getPlayerInjuries(playerId, controller.signal);
        if (!alive) return;
        setResult(res?.success && res.data?.available === true ? res.data : null);
      } catch (e) {
        /* aborted or network failure — pill and block simply stay hidden */
      }
    })();
    return () => {
      alive = false;
      controller.abort();
    };
  }, [playerId]);

  return result;
};

export default usePlayerInjuries;
